import { __assign, __awaiter, __generator, __read } from "tslib";
import React, { useEffect } from 'react';
import { Select } from '@hose/eui';
import { app } from '@ekuaibao/whispered';
import { getTagLabel } from '../../util';
import { formatStaffToTagData } from "../staff-select-heavy/utile";
import { getDisplayName } from "../../utilFn";
export var Index = function (_a) {
    var placeholder = _a.placeholder, checkedIds = _a.checkedIds, multiple = _a.multiple, onChange = _a.onChange, fetchData = _a.fetchData, selectedOptions = _a.selectedOptions;
    var _b = __read(React.useState([]), 2), options = _b[0], setOptions = _b[1];
    useEffect(function () {
        getStaffs();
    }, []);
    var getStaffs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var staffs, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getStaffData(fetchData)];
                case 1:
                    staffs = _a.sent();
                    data = staffs === null || staffs === void 0 ? void 0 : staffs.map(function (staff) { return formatStaffToTagData(staff); });
                    setOptions(data);
                    return [2];
            }
        });
    }); };
    var handleChange = function (value) {
        if (multiple) {
            onChange === null || onChange === void 0 ? void 0 : onChange(value, options.filter(function (item) { return value.includes(item.id); }));
        }
        else {
            var data_1 = !!value ? [value] : [];
            onChange === null || onChange === void 0 ? void 0 : onChange(data_1, options.filter(function (item) { return data_1.includes(item.id); }));
        }
    };
    return (React.createElement(Select, __assign({ placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : i18n.get('请选择人员'), value: checkedIds, mode: multiple ? 'multiple' : undefined, allowClear: true, showSearch: true, showArrow: true, virtual: true, optionFilterProp: "children", onChange: handleChange, style: { width: '100%' }, filterOption: function (input, option) {
            var _a, _b, _c, _d;
            var name = getDisplayName(option.data).toLowerCase();
            var nameInitial = ((_b = (_a = option.data) === null || _a === void 0 ? void 0 : _a.nameInitial) !== null && _b !== void 0 ? _b : '').toLowerCase();
            var nameSpell = ((_d = (_c = option.data) === null || _c === void 0 ? void 0 : _c.nameSpell) !== null && _d !== void 0 ? _d : '').toLowerCase();
            return (name.includes(input.toLowerCase()) ||
                (nameInitial.includes(input.toLowerCase()) && i18n.currentLocale === 'zh-CN') ||
                (nameSpell.includes(input.toLowerCase()) && i18n.currentLocale === 'zh-CN'));
        } }, selectedOptions), options.map(function (item) {
        return (React.createElement(Select.Option, { key: item.id, value: item.id, data: item }, getTagLabel(item, true)));
    })));
};
var getStaffData = function (fetchData) { return __awaiter(void 0, void 0, void 0, function () {
    var staffs;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                staffs = [];
                if (!fetchData) return [3, 2];
                return [4, fetchData()];
            case 1:
                staffs = _a.sent();
                return [3, 4];
            case 2: return [4, app.dataLoader('@common.staffs').load()];
            case 3:
                staffs = _a.sent();
                _a.label = 4;
            case 4: return [2, staffs];
        }
    });
}); };
export default Index;
